import CardSummary from "../Card";

interface IInformationProps {
  isMobile: boolean;
  dateSummary: string;
  timeSummary: string;
  durationSummary: string;
  totalQuestionSummary: number;
}

const Information = ({
  isMobile,
  timeSummary,
  dateSummary,
  durationSummary,
  totalQuestionSummary,
}: IInformationProps) => {
  const containerClass = `${
    isMobile ? "grid-cols-1" : "grid grid-cols-2"
  } grid gap-6 mb-10`;

  return (
    <section aria-labelledby="information-title">
      <div className="mt-9 mb-5">
        <h1
          className="text-color-02 font-bold text-subheading-01"
          id="information-title"
        >
          Información
        </h1>
      </div>
      <div className={containerClass}>
        <CardSummary icon="calendar" title="Fecha" description={dateSummary} />
        <CardSummary icon="clock" title="Hora" description={timeSummary} />
        <CardSummary
          icon="edit-3"
          title="Tiempo de duración"
          description={durationSummary}
        />
        <CardSummary
          icon="file-text"
          title="Total de preguntas"
          description={`${totalQuestionSummary} preguntas`}
        />
      </div>
    </section>
  );
};

export default Information;
